// extracted by mini-css-extract-plugin
export default {"container":"Transplants_container__41Lm+","title":"Transplants_title__43DpU","select":"Transplants_select__XY19T"};